export var getCreditScore = function getCreditScore(identity) {
  var _identity$profiles, _identity$profiles$tu;
  return identity === null || identity === void 0 ? void 0 : (_identity$profiles = identity.profiles) === null || _identity$profiles === void 0 ? void 0 : (_identity$profiles$tu = _identity$profiles.tu_credit_report_profile) === null || _identity$profiles$tu === void 0 ? void 0 : _identity$profiles$tu.vantage_score_3;
};
export var isSignedIn = function isSignedIn(identity) {
  return identity.isSignedIn;
};